import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useGuestSession } from "contexts/GuestSessionContext";
import GuestBottomNav from "./components/GuestBottomNav";
import GuestHeader from "./components/GuestHeader";
import CustomerLookupDialog from "pages/RestaurantMenu/components/CustomerLookupDialog";
import { sanitizePhoneNumber, isValidPhoneNumber } from "utils/phoneUtils";
import { LUXURY } from "data/guestLuxuryTheme";
import { GuestHubSearchProvider } from "./GuestHubSearchContext";

const GuestPortalShell = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const session = useGuestSession();
  const isMenuRoute =
    location.pathname.startsWith("/guest/dine") ||
    location.pathname.startsWith("/guest/room-service");

  const isCustomerMobileInvalid =
    session.customerMobileInput.length > 0 &&
    !isValidPhoneNumber(session.customerMobileInput);

  const lookupDialog = (
    <CustomerLookupDialog
      open={session.customerPromptOpen}
      isMobile={isMobile}
      companyName={session.company?.name}
      mobileValue={session.customerMobileInput}
      onMobileChange={(value) =>
        session.setCustomerMobileInput(sanitizePhoneNumber(value).slice(0, 15))
      }
      isMobileInvalid={isCustomerMobileInvalid}
      onSkip={session.skipCustomer}
      onContinue={session.lookupCustomer}
      isLoading={session.customerLookupLoading}
      continueDisabled={isCustomerMobileInvalid}
      luxury
      buttonGradient={LUXURY.ctaGradient}
      buttonGradientHover={LUXURY.ctaGradientHover}
      buttonShadow={LUXURY.ctaShadow}
      buttonShadowHover={LUXURY.ctaShadowHover}
    />
  );

  if (isMenuRoute) {
    return (
      <>
        {children}
        {lookupDialog}
      </>
    );
  }

  return (
    <GuestHubSearchProvider>
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: LUXURY.page,
          backgroundImage:
            "radial-gradient(ellipse 120% 60% at 50% -10%, rgba(201,166,107,0.08), transparent 55%)",
          color: LUXURY.ink,
          pb: "88px",
          fontFamily: LUXURY.bodyFont,
        }}
      >
        <GuestHeader session={session} />

        {children}
        <GuestBottomNav search={session.guestSearch} />
        {lookupDialog}
      </Box>
    </GuestHubSearchProvider>
  );
};

export default GuestPortalShell;
